export const stringSanitize = (val?: string) => val?.replace(/[^a-zA-Z0-9]/g, '_')
